const orderStatus = {
  elevation: '0 8px 34px -12px $grape_60',
  background: '$white',
  orderCardBackground: '$deep_purple',
};

export default orderStatus;
